import { render, staticRenderFns } from "./AcHistory.vue?vue&type=template&id=22c1ae8c&scoped=true&"
import script from "./AcHistory.vue?vue&type=script&lang=js&"
export * from "./AcHistory.vue?vue&type=script&lang=js&"
import style0 from "./AcHistory.vue?vue&type=style&index=0&id=22c1ae8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c1ae8c",
  null
  
)

export default component.exports